(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-artwork-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var MAX_BYTES = 20000000;
  var MAX_PIXELS = 20000000;
  var MAX_SIDE = 16384;
  var instances = new Map();

  function checkError(code) {
    var error = new Error(code);
    error.code = code;
    return error;
  }

  function inspectPng(buffer) {
    var bytes = new Uint8Array(buffer);
    if (bytes.byteLength > MAX_BYTES) throw checkError('large');
    var signature = [137, 80, 78, 71, 13, 10, 26, 10];
    if (bytes.byteLength < 45 || signature.some(function (byte, index) { return bytes[index] !== byte; })) throw checkError('format');
    var view = new DataView(buffer);
    var width = 0, height = 0, imageData = false, palette = false, color = null;
    var offset = 8;
    while (offset + 12 <= bytes.byteLength) {
      var length = view.getUint32(offset);
      if (length > bytes.byteLength - offset - 12) throw checkError('format');
      var type = String.fromCharCode(bytes[offset + 4], bytes[offset + 5], bytes[offset + 6], bytes[offset + 7]);
      if (!/^[A-Za-z]{4}$/.test(type)) throw checkError('format');
      if (type === 'acTL' || type === 'fcTL' || type === 'fdAT') throw checkError('animated');
      if (offset === 8 && type !== 'IHDR') throw checkError('format');
      if (type === 'IHDR') {
        if (offset !== 8 || length !== 13) throw checkError('format');
        width = view.getUint32(offset + 8);
        height = view.getUint32(offset + 12);
        if (!width || !height) throw checkError('format');
        if (width > MAX_SIDE || height > MAX_SIDE || width * height > MAX_PIXELS) throw checkError('dimensions');
        var depth = bytes[offset + 16];
        color = bytes[offset + 17];
        var depths = {0: [1, 2, 4, 8, 16], 2: [8, 16], 3: [1, 2, 4, 8], 4: [8, 16], 6: [8, 16]};
        if (!depths[color] || depths[color].indexOf(depth) < 0 || bytes[offset + 18] !== 0 || bytes[offset + 19] !== 0 || bytes[offset + 20] > 1) throw checkError('format');
        var crc = 0xffffffff;
        for (var c = offset + 4; c < offset + 8 + length; c++) {
          crc ^= bytes[c];
          for (var bit = 0; bit < 8; bit++) crc = (crc >>> 1) ^ ((crc & 1) ? 0xedb88320 : 0);
        }
        if (((crc ^ 0xffffffff) >>> 0) !== view.getUint32(offset + 8 + length)) throw checkError('format');
      }
      if (type === 'PLTE') {
        if (palette || imageData || !length || length % 3 || length > 768) throw checkError('format');
        palette = true;
      }
      if (type === 'IDAT') {
        if (color === 3 && !palette) throw checkError('format');
        imageData = true;
      }
      offset += length + 12;
      if (type === 'IEND') {
        if (length || !imageData || offset !== bytes.byteLength) throw checkError('format');
        return {width: width, height: height};
      }
    }
    throw checkError('format');
  }

  function ppiForWidth(pixels, value, unit) {
    if (String(value).trim() === '' || (unit !== 'in' && unit !== 'cm')) return null;
    var width = Number(value);
    var inches = unit === 'cm' ? width / 2.54 : width;
    var ppi = pixels / inches;
    return Number.isFinite(width) && width > 0 && Number.isFinite(ppi) && ppi > 0 ? ppi : null;
  }

  async function scanAlpha(image, size, isCurrent) {
    var canvas = document.createElement('canvas');
    canvas.width = size.width;
    canvas.height = size.height;
    try {
      var context = canvas.getContext('2d', {willReadFrequently: true});
      if (!context) throw checkError('decode');
      context.drawImage(image, 0, 0);
      var rows = Math.max(1, Math.floor(262144 / size.width));
      var transparent = false, visible = false;
      for (var y = 0; y < size.height; y += rows) {
        if (!isCurrent()) throw checkError('stale');
        var data = context.getImageData(0, y, size.width, Math.min(rows, size.height - y)).data;
        for (var pixel = 3; pixel < data.length; pixel += 4) {
          if (data[pixel] < 255) transparent = true;
          if (data[pixel] > 0) visible = true;
          if (transparent && visible) return 'some';
        }
        await new Promise(function (resolve) { setTimeout(resolve, 0); });
      }
      return !visible ? 'all' : 'none';
    } finally {
      canvas.width = 0;
      canvas.height = 0;
    }
  }

  function initialize(root) {
    if (instances.has(root)) instances.get(root)();
    var file = root.querySelector('[data-png-file]');
    var reset = root.querySelector('[data-png-reset]');
    var status = root.querySelector('[data-png-status]');
    var results = root.querySelector('[data-png-results]');
    var dimensions = root.querySelector('[data-png-dimensions]');
    var alpha = root.querySelector('[data-png-alpha]');
    var printWidth = root.querySelector('[data-png-width]');
    var unit = root.querySelector('[data-png-unit]');
    var ppi = root.querySelector('[data-png-ppi]');
    var images = Array.from(root.querySelectorAll('[data-png-preview]'));
    var generation = 0, disposed = false, objectUrl = null, cancelDecode = null, size = null;
    var previousUnit = unit.value;
    var listeners = [];
    function on(element, event, handler) {
      element.addEventListener(event, handler);
      listeners.push(function () { element.removeEventListener(event, handler); });
    }
    function release() {
      generation++;
      if (cancelDecode) cancelDecode();
      images.forEach(function (image) { image.removeAttribute('src'); });
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = null;
      size = null;
      results.hidden = true;
      dimensions.textContent = '';
      alpha.textContent = '';
      ppi.textContent = '—';
      root.setAttribute('aria-busy', 'false');
    }
    function clear() {
      release();
      file.value = '';
      printWidth.value = '';
      status.textContent = root.dataset.ready;
      reset.disabled = true;
    }
    function updatePpi() {
      var value = size && printWidth.validity.valid ? ppiForWidth(size.width, printWidth.value, unit.value) : null;
      ppi.textContent = value === null ? '—' : value.toLocaleString(undefined, {maximumFractionDigits: 1});
    }
    function decode(url) {
      return new Promise(function (resolve, reject) {
        var image = new Image();
        var finished = false;
        var timeout = setTimeout(function () { finish(checkError('decode')); }, 15000);
        function finish(error) {
          if (finished) return;
          finished = true;
          clearTimeout(timeout);
          image.onload = null;
          image.onerror = null;
          if (cancelDecode === cancel) cancelDecode = null;
          if (error) { image.removeAttribute('src'); reject(error); }
          else resolve(image);
        }
        function cancel() { finish(checkError('stale')); }
        cancelDecode = cancel;
        image.onload = function () { finish(null); };
        image.onerror = function () { finish(checkError('decode')); };
        image.decoding = 'async';
        image.src = url;
      });
    }
    async function choose() {
      release();
      var selected = file.files && file.files[0];
      var token = generation;
      function current() { return !disposed && token === generation; }
      reset.disabled = !selected;
      if (!selected) { status.textContent = root.dataset.ready; return; }
      status.textContent = root.dataset.checking;
      root.setAttribute('aria-busy', 'true');
      try {
        if (!selected.size || selected.size > MAX_BYTES) throw checkError(selected.size ? 'large' : 'format');
        var buffer = await selected.arrayBuffer();
        if (!current()) return;
        var parsed = inspectPng(buffer);
        objectUrl = URL.createObjectURL(new Blob([buffer], {type: 'image/png'}));
        var image = await decode(objectUrl);
        if (!current()) return;
        if (image.naturalWidth !== parsed.width || image.naturalHeight !== parsed.height) throw checkError('decode');
        var transparency = await scanAlpha(image, parsed, current);
        if (!current()) return;
        size = parsed;
        dimensions.textContent = parsed.width.toLocaleString() + ' × ' + parsed.height.toLocaleString();
        alpha.textContent = root.dataset[transparency === 'all' ? 'alphaAll' : transparency === 'some' ? 'alphaSome' : 'alphaNone'];
        images.forEach(function (preview) {
          preview.width = parsed.width;
          preview.height = parsed.height;
          preview.src = objectUrl;
        });
        results.hidden = false;
        updatePpi();
        status.textContent = root.dataset.done;
      } catch (error) {
        if (!current() || error.code === 'stale') return;
        var key = {format: 'errorFormat', large: 'errorLarge', dimensions: 'errorDimensions', animated: 'errorAnimated'}[error.code] || 'errorDecode';
        release();
        status.textContent = root.dataset[key];
      } finally {
        if (current()) root.setAttribute('aria-busy', 'false');
      }
    }
    file.disabled = false;
    clear();
    on(file, 'change', choose);
    on(file, 'cancel', function () { if (!file.files || !file.files.length) clear(); });
    on(reset, 'click', clear);
    on(printWidth, 'input', updatePpi);
    on(unit, 'change', function () {
      var value = Number(printWidth.value);
      if (printWidth.value !== '' && Number.isFinite(value) && value > 0 && unit.value !== previousUnit) {
        printWidth.value = String(Number((value * (unit.value === 'cm' ? 2.54 : 1 / 2.54)).toFixed(4)));
      }
      previousUnit = unit.value;
      updatePpi();
    });
    instances.set(root, function () {
      disposed = true;
      release();
      listeners.forEach(function (remove) { remove(); });
      file.value = '';
      file.disabled = true;
      instances.delete(root);
    });
  }

  function initializeWithin(scope) {
    if (scope.matches && scope.matches('[data-png-check]')) initialize(scope);
    scope.querySelectorAll('[data-png-check]').forEach(initialize);
  }
  function unloadWithin(scope) {
    Array.from(instances.entries()).forEach(function (entry) {
      if (scope === entry[0] || scope.contains(entry[0])) entry[1]();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, {once: true});
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unloadWithin(event.target); });
  window.addEventListener('pagehide', function () { unloadWithin(document); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) initializeWithin(document); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbd-planning-quantity"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bbd-sheet-quantity')) {
  class BbdSheetQuantity extends HTMLElement {
    static plan(rawRows) {
      if (!Array.isArray(rawRows) || rawRows.length !== 4) return { ok: false, code: 'configuration', row: 0, field: 'need' };
      const rows = [];
      for (let index = 0; index < rawRows.length; index += 1) {
        const needRaw = String(rawRows[index].need ?? '').trim();
        const perRaw = String(rawRows[index].per ?? '').trim();
        if (index > 0 && needRaw === '' && perRaw === '') continue;
        if (needRaw === '' || perRaw === '') {
          return { ok: false, code: index === 0 ? 'required' : 'pair', row: index, field: needRaw === '' ? 'need' : 'per' };
        }
        for (const [field, raw] of [['need', needRaw], ['per', perRaw]]) {
          const number = Number(raw);
          if (!/^[0-9]+$/.test(raw) || !Number.isSafeInteger(number) || number < 1 || number > 1000000) return { ok: false, code: 'invalid', row: index, field };
        }
        const needed = Number(needRaw);
        const perSheet = Number(perRaw);
        rows.push({ row: index, needed, perSheet, requiredSheets: Math.ceil(needed / perSheet) });
      }
      const sheets = Math.max(...rows.map((row) => row.requiredSheets));
      const results = rows.map((row) => ({ ...row, produced: sheets * row.perSheet, extras: sheets * row.perSheet - row.needed }));
      return { ok: true, sheets, rows: results, hasExtras: results.some((row) => row.extras > 0) };
    }

    connectedCallback() {
      if (this.initialized) return;
      this.rows = Array.from(this.querySelectorAll('[data-row]')).map((row) => ({
        letter: row.dataset.design,
        need: row.querySelector('[data-needed-input]'),
        per: row.querySelector('[data-per-input]')
      }));
      this.calculateButton = this.querySelector('[data-calculate]');
      this.exampleButton = this.querySelector('[data-example-button]');
      this.resetButton = this.querySelector('[data-reset-button]');
      this.error = this.querySelector('[data-error]');
      this.status = this.querySelector('[data-status]');
      this.results = this.querySelector('[data-results]');
      this.resultHeading = this.querySelector('[data-result-heading]');
      this.resultNote = this.querySelector('[data-result-note]');
      this.cards = this.querySelector('[data-result-cards]');
      if (this.rows.length !== 4 || this.rows.some((row) => !row.need || !row.per) || !this.calculateButton || !this.exampleButton || !this.resetButton || !this.error || !this.status || !this.results || !this.resultHeading || !this.resultNote || !this.cards) return;
      this.initialized = true;
      this.inputs = this.rows.flatMap((row) => [row.need, row.per]);
      this.numberFormat = new Intl.NumberFormat('en-US');
      this.inputs.forEach((input) => {
        input.addEventListener('input', () => {
          const hadResult = !this.results.hidden;
          this.clearFeedback();
          if (hadResult) this.status.textContent = this.dataset.stale;
        });
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && !event.isComposing) {
            event.preventDefault();
            this.calculate();
          }
        });
      });
      this.calculateButton.addEventListener('click', () => this.calculate());
      this.exampleButton.addEventListener('click', () => {
        this.clearFeedback();
        this.rows.forEach((row) => { row.need.value = ''; row.per.value = ''; });
        this.rows[0].need.value = '12';
        this.rows[0].per.value = '2';
        this.rows[1].need.value = '24';
        this.rows[1].per.value = '4';
        this.status.textContent = this.dataset.example;
        this.rows[0].need.focus();
      });
      this.resetButton.addEventListener('click', () => {
        this.clearFeedback();
        this.inputs.forEach((input) => { input.value = ''; });
        this.status.textContent = this.dataset.reset;
        this.rows[0].need.focus();
      });
      [this.calculateButton, this.exampleButton, this.resetButton].forEach((button) => { button.disabled = false; });
      const fallback = this.querySelector('[data-fallback]');
      if (fallback) fallback.hidden = true;
    }

    clearFeedback() {
      this.results.hidden = true;
      this.cards.replaceChildren();
      this.resultHeading.textContent = '';
      this.resultNote.textContent = '';
      this.error.hidden = true;
      this.error.textContent = '';
      this.status.textContent = '';
      this.inputs.forEach((input) => {
        input.removeAttribute('aria-invalid');
        const ids = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== this.error.id);
        input.setAttribute('aria-describedby', ids.join(' '));
      });
    }

    calculate() {
      this.clearFeedback();
      const plan = BbdSheetQuantity.plan(this.rows.map((row) => ({ need: row.need.value, per: row.per.value })));
      if (!plan.ok) {
        const row = this.rows[plan.row];
        const input = row[plan.field];
        const message = plan.code === 'required' ? this.dataset.required : plan.code === 'pair' ? this.dataset.pair : this.dataset.invalid;
        this.error.textContent = message.replace('{design}', row.letter);
        this.error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', (input.getAttribute('aria-describedby') + ' ' + this.error.id).trim());
        input.focus();
        return;
      }
      const summary = plan.sheets === 1 ? this.dataset.resultOne : this.dataset.resultMany.replace('{sheets}', this.numberFormat.format(plan.sheets));
      this.resultHeading.textContent = summary;
      this.resultNote.textContent = plan.hasExtras ? this.dataset.extras : this.dataset.exact;
      const cards = plan.rows.map((row) => {
        const card = document.createElement('li');
        const heading = document.createElement('h4');
        heading.textContent = this.dataset.design + ' ' + this.rows[row.row].letter;
        const list = document.createElement('dl');
        [[this.dataset.needed, row.needed], [this.dataset.produced, row.produced], [this.dataset.extra, row.extras]].forEach(([label, value], index) => {
          const term = document.createElement('dt');
          const count = document.createElement('dd');
          term.textContent = label;
          count.textContent = this.numberFormat.format(value);
          if (index === 2 && value > 0) count.className = 'bbd-quantity__extra';
          list.append(term, count);
        });
        card.append(heading, list);
        return card;
      });
      this.cards.replaceChildren(...cards);
      this.results.hidden = false;
      this.status.textContent = this.dataset.ready;
      this.resultHeading.focus();
    }
  }
  customElements.define('bbd-sheet-quantity', BbdSheetQuantity);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbdtf-builder-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bbdtf-builder-reviews')) {
    class BbdtfBuilderReviews extends HTMLElement {
      connectedCallback() {
        if (this.stop) return;
        const productId = this.dataset.productId;
        const vendor = this.querySelector('.bbdtf-native-reviews');
        const details = this.querySelector('.bbdtf-review-reading');
        if (details) details.hidden = true;
        if (this.dataset.productHandle !== 'build-a-gang-sheet' || !/^\d+$/.test(productId || '')) return;
        const sources = this.querySelectorAll(':scope > .bbdtf-review-source');
        if (!vendor || !details || sources.length !== 1) return;
        if (this.readingBuilt && (this.builtProductId !== productId || this.builtSourceText !== sources[0].textContent)) {
          details.hidden = true;
          return;
        }

        const one = (root, selector) => {
          const nodes = root.querySelectorAll(selector);
          if (nodes.length !== 1) throw new Error('Unexpected review schema');
          return nodes[0];
        };
        const text = (node) => {
          const value = node.textContent.trim();
          if (!value) throw new Error('Empty review field');
          return value;
        };
        const element = (tag, className, value) => {
          const node = document.createElement(tag);
          if (className) node.className = className;
          if (value !== undefined) node.textContent = value;
          return node;
        };
        const safeUrl = (raw, image) => {
          if (typeof raw !== 'string' || !raw.trim()) return null;
          try {
            const url = new URL(raw, location.href);
            if (url.protocol !== 'https:' || url.username || url.password) return null;
            if (image) {
              if (url.hostname !== 'images.loox.io') return null;
            } else if (url.origin !== location.origin || !url.pathname.startsWith('/products/')) {
              return null;
            }
            return raw;
          } catch {
            return null;
          }
        };
        const time = (source) => {
          const date = source.getAttribute('datetime');
          if (!date || !Number.isFinite(Date.parse(date))) throw new Error('Invalid review date');
          const node = element('time', '', text(source));
          node.dateTime = date;
          return node;
        };

        if (!this.readingBuilt) {
          try {
            const markup = JSON.parse(sources[0].textContent);
            if (typeof markup !== 'string') return;
            const template = document.createElement('template');
            template.innerHTML = markup;
            const widget = one(template.content, '#looxReviews');
            if (widget.dataset.productId !== productId || widget.dataset.reviewsToDisplay !== 'product_reviews_only') return;
            const feed = one(widget, '#loox-reviews-feed');
            const heading = text(one(feed, 'section > h3'));
            const summary = text(one(feed, '.loox-ssr-review-summary'));
            const records = Array.from(feed.querySelectorAll('article.loox-review'));
            const limit = Number(widget.dataset.limit);
            const totalMatch = summary.match(/^Overall rating:\s*(?:[0-4](?:\.\d+)?|5(?:\.0+)?)\s*\/\s*5\s+from\s+(\d+)\s+reviews?\.$/);
            const total = totalMatch && Number(totalMatch[1]);
            if (!Number.isSafeInteger(total) || total < 1 || !Number.isSafeInteger(limit) || limit < 1 || records.length !== Math.min(total, limit)) return;
            const ids = new Set();
            const list = document.createDocumentFragment();
            for (const record of records) {
              const id = record.dataset.reviewId;
              if (record.dataset.productId !== productId || !id || ids.has(id)) throw new Error('Invalid review identity');
              ids.add(id);
              const item = element('li', 'bbdtf-review-item');
              const article = element('article');
              item.append(article);
              const mediaLinks = Array.from(record.querySelectorAll('.loox-review-media-link'));
              if (mediaLinks.length !== record.querySelectorAll('.loox-review-image').length) throw new Error('Unexpected review media');
              if (mediaLinks.length) {
                const media = element('div', 'bbdtf-review-media');
                for (const sourceLink of mediaLinks) {
                  const sourceImage = one(sourceLink, 'img.loox-review-image');
                  const href = safeUrl(sourceLink.getAttribute('href'), false);
                  const src = safeUrl(sourceImage.getAttribute('src'), true);
                  if (!src) {
                    const alt = sourceImage.getAttribute('alt');
                    if (alt) media.append(element('span', '', alt));
                    continue;
                  }
                  const image = element('img');
                  image.setAttribute('src', src);
                  image.alt = sourceImage.getAttribute('alt') || '';
                  image.loading = 'lazy';
                  image.decoding = 'async';
                  for (const dimension of ['width', 'height']) {
                    const value = sourceImage.getAttribute(dimension);
                    if (/^[1-9]\d*$/.test(value || '')) image.setAttribute(dimension, value);
                  }
                  if (href) {
                    const link = element('a');
                    link.setAttribute('href', href);
                    link.rel = 'nofollow';
                    if (!image.alt) link.setAttribute('aria-label', text(one(record, '.loox-review-product-link')));
                    link.append(image);
                    media.append(link);
                  } else {
                    media.append(image);
                  }
                }
                article.append(media);
              }
              article.append(element('p', 'bbdtf-review-body', text(one(record, '.loox-review-body'))));
              const metadata = element('p', 'bbdtf-review-metadata');
              const names = record.querySelectorAll('.loox-reviewer-name');
              const verified = record.querySelectorAll('.loox-review-verified');
              if (names.length > 1 || verified.length > 1) throw new Error('Unexpected review metadata');
              if (names.length && names[0].textContent.trim()) metadata.append(element('strong', '', text(names[0])));
              const rating = text(one(record, '.loox-review-rating'));
              if (!/^[1-5]\/5$/.test(rating)) throw new Error('Invalid review rating');
              metadata.append(element('span', '', rating));
              if (verified.length && verified[0].textContent.trim()) metadata.append(element('span', '', text(verified[0])));
              metadata.append(time(one(record, '.loox-review-date')));
              article.append(metadata);
              const productLine = one(record, '.loox-review-product');
              const productLink = one(productLine, 'a.loox-review-product-link');
              const product = element('p', 'bbdtf-review-product');
              for (const child of productLine.childNodes) {
                if (child === productLink) {
                  const href = safeUrl(productLink.getAttribute('href'), false);
                  if (href) {
                    const link = element('a', '', text(productLink));
                    link.setAttribute('href', href);
                    product.append(link);
                  } else {
                    product.append(document.createTextNode(text(productLink)));
                  }
                } else {
                  product.append(document.createTextNode(child.textContent));
                }
              }
              article.append(product);
              const replies = record.querySelectorAll('.loox-review-reply');
              if (replies.length > 1) throw new Error('Unexpected merchant replies');
              if (replies.length) {
                const reply = element('div', 'bbdtf-review-reply');
                const replyMetadata = element('p', 'bbdtf-review-metadata');
                replyMetadata.append(element('strong', '', text(one(replies[0], '.loox-review-reply-label'))));
                replyMetadata.append(time(one(replies[0], '.loox-review-reply-date')));
                reply.append(replyMetadata);
                const replyBody = one(replies[0], '.loox-review-reply-body').cloneNode(true);
                replyBody.querySelectorAll('.loox-review-reply-label, .loox-review-reply-date').forEach((node) => node.remove());
                reply.append(element('p', 'bbdtf-review-reply-body', text(replyBody)));
                article.append(reply);
              }
              list.append(item);
            }
            one(details, 'summary').textContent = heading;
            one(details, '.bbdtf-review-summary').textContent = summary;
            one(details, '.bbdtf-review-list').append(list);
            this.readingBuilt = true;
            this.builtProductId = productId;
            this.builtSourceText = sources[0].textContent;
          } catch {
            return;
          }
        }

        let frame = null;
        const resize = new ResizeObserver(() => update());
        const update = () => {
          if (!this.isConnected || this.dataset.productId !== productId || this.dataset.productHandle !== 'build-a-gang-sheet') {
            details.hidden = true;
            if (this.stop) this.stop();
            return;
          }
          const widget = vendor.querySelector('#looxReviews');
          if (widget && widget.dataset.productId !== productId) {
            details.hidden = true;
            if (this.stop) this.stop();
            return;
          }
          const next = widget && widget.dataset.productId === productId ? widget.querySelector('#looxReviewsFrame') : null;
          if (next !== frame) {
            resize.disconnect();
            frame = next;
            if (frame) resize.observe(frame);
          }
          const rect = frame && frame.getBoundingClientRect();
          const style = frame && getComputedStyle(frame);
          const visible = frame && rect.height > 0 && rect.width > 0 && style.display !== 'none' && style.visibility !== 'hidden';
          details.hidden = Boolean(visible && !details.open && !details.contains(document.activeElement));
        };
        const mutation = new MutationObserver(update);
        mutation.observe(vendor, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class', 'height', 'hidden', 'data-product-id'] });
        mutation.observe(this, { attributes: true, attributeFilter: ['data-product-id', 'data-product-handle'] });
        const afterFocus = () => queueMicrotask(update);
        details.addEventListener('toggle', update);
        details.addEventListener('focusout', afterFocus);
        this.stop = () => {
          resize.disconnect();
          mutation.disconnect();
          details.removeEventListener('toggle', update);
          details.removeEventListener('focusout', afterFocus);
          this.stop = null;
        };
        update();
      }

      disconnectedCallback() {
        if (this.stop) this.stop();
      }
    }
    customElements.define('bbdtf-builder-reviews', BbdtfBuilderReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbdtf-transfer-cost"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('bbdtf-transfer-cost')) return;
    class BbdtfTransferCost extends HTMLElement {
      static money(raw, optional = false) {
        const value = String(raw).trim();
        if (optional && value === '') return undefined;
        if (value.length > 32 || !/^(?:\d+(?:\.\d{0,2})?|\.\d{1,2})$/.test(value)) return null;
        const parts = value.split('.');
        const cents = Number(parts[0] || '0') * 100 + Number((parts[1] || '').padEnd(2, '0'));
        return Number.isSafeInteger(cents) && cents >= 0 && cents <= 99999999 ? cents : null;
      }
      static copies(raw) {
        const value = String(raw).trim();
        if (value.length > 32 || !/^\d+$/.test(value)) return null;
        const count = Number(value);
        return Number.isSafeInteger(count) && count >= 1 && count <= 1000000 ? count : null;
      }
      static roundedRatio(cents, count, multiplier = 1) {
        return Math.floor((2 * cents * multiplier + count) / (2 * count));
      }
      connectedCallback() {
        this.controller?.abort();
        this.fieldset = this.querySelector('fieldset');
        this.fields = {
          batch: this.querySelector('[data-cost-batch]'),
          copies: this.querySelector('[data-cost-copies]'),
          additional: this.querySelector('[data-cost-additional]')
        };
        this.calculateButton = this.querySelector('[data-cost-calculate]');
        this.resetButton = this.querySelector('[data-cost-reset]');
        this.results = this.querySelector('[data-cost-results]');
        if (!this.fieldset || Object.values(this.fields).some(field => !field) || !this.calculateButton || !this.resetButton || !this.results) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.calculateButton.addEventListener('click', () => this.calculate(), options);
        this.resetButton.addEventListener('click', () => this.resetValues(), options);
        this.addEventListener('input', event => {
          if (Object.values(this.fields).includes(event.target)) this.clear();
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Enter' && !event.isComposing && Object.values(this.fields).includes(event.target)) {
            event.preventDefault();
            this.calculate();
          }
        }, options);
        this.clear();
        this.fieldset.disabled = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        if (this.fieldset) this.fieldset.disabled = true;
      }
      clear() {
        this.results.hidden = true;
        Object.values(this.fields).forEach(field => field.removeAttribute('aria-invalid'));
        this.querySelectorAll('[data-cost-error]').forEach(node => { node.hidden = true; node.textContent = ''; });
        this.querySelectorAll('[data-cost-output]').forEach(node => { node.textContent = ''; });
        this.querySelectorAll('[data-cost-extra]').forEach(node => { node.hidden = true; });
      }
      resetValues() {
        Object.values(this.fields).forEach(field => { field.value = ''; });
        this.clear();
        this.fields.batch.focus();
      }
      showError(key, message) {
        this.fields[key].setAttribute('aria-invalid', 'true');
        const error = this.querySelector('[data-cost-error="' + key + '"]');
        error.textContent = message;
        error.hidden = false;
      }
      format(amount, digits = 2) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: digits, maximumFractionDigits: digits }).format(amount);
      }
      average(cents, count, detail = false) {
        const rounded = BbdtfTransferCost.roundedRatio(cents, count, detail ? 100 : 1);
        if (cents > 0 && rounded === 0) return detail ? this.dataset.tinyDetail : this.dataset.tinyCents;
        return this.format(rounded / (detail ? 10000 : 100), detail ? 4 : 2);
      }
      output(key, value) {
        this.querySelector('[data-cost-output="' + key + '"]').textContent = value;
      }
      calculate() {
        this.clear();
        const cents = BbdtfTransferCost.money(this.fields.batch.value);
        const count = BbdtfTransferCost.copies(this.fields.copies.value);
        const additional = BbdtfTransferCost.money(this.fields.additional.value, true);
        const errors = [];
        if (cents === null) errors.push(['batch', this.dataset.errorMoney]);
        if (count === null) errors.push(['copies', this.dataset.errorCount]);
        if (additional === null) errors.push(['additional', this.dataset.errorMoney]);
        if (cents !== null && additional !== null && additional !== undefined && (!Number.isSafeInteger(cents + additional) || cents + additional > 99999999)) errors.push(['additional', this.dataset.errorCombined]);
        if (errors.length) {
          errors.forEach(([key, message]) => this.showError(key, message));
          this.fields[errors[0][0]].focus();
          return;
        }
        this.output('sheet_total', this.format(cents / 100));
        this.output('sheet_average', this.average(cents, count));
        this.output('sheet_detail', this.average(cents, count, true));
        if (additional !== undefined) {
          const total = cents + additional;
          this.output('entered_total', this.format(total / 100));
          this.output('entered_average', this.average(total, count));
          this.output('entered_detail', this.average(total, count, true));
          this.querySelectorAll('[data-cost-extra]').forEach(node => { node.hidden = false; });
        }
        this.results.hidden = false;
      }
    }
    customElements.define('bbdtf-transfer-cost', BbdtfTransferCost);
  })();

  } catch(e) { console.error(e); }
})();
})();
